import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { collection, onSnapshot } from 'firebase/firestore';
import {
  Box, Typography, List, ListItem, ListItemText, Chip, Stack, Divider
} from '@mui/material';

const ListaClientes = () => {
  const [clientes, setClientes] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'clientes'), (snapshot) => {
      const lista = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setClientes(lista);
    });
    return () => unsub();
  }, []);

  const totalGeneral = clientes.reduce(
    (acc, c) => acc + (parseFloat(c.deudaTotal ?? 0) || 0),
    0
  );

  return (
    <Box
      sx={{
        mt: 4,
        p: 3,
        backgroundColor: 'white',
        borderRadius: 2,
        boxShadow: 3,
        maxWidth: 800,
        mx: 'auto',
        width: '100%',
        pb: 10,              // <— espacio extra para el BottomNavigation
      }}
    >
      <Typography variant="h4" gutterBottom>
        Lista de Clientes
      </Typography>

      {/* TOTAL GENERAL ARRIBA */}
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Typography variant="h6">
          Total general deuda: Q {totalGeneral.toFixed(2)}
        </Typography>
      </Stack>

      <List>
        {clientes.map((c) => {
          const deuda = parseFloat(c.deudaTotal ?? 0) || 0;
          return (
            <React.Fragment key={c.id}>
              <ListItem sx={{ alignItems: 'flex-start' }}>
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography sx={{ fontWeight: 'bold' }}>{c.nombre}</Typography>
                      <Chip
                        size="small"
                        label={c.activo ? 'Activo' : 'Inactivo'}
                        color={c.activo ? 'success' : 'default'}
                        variant="outlined"
                      />
                    </Stack>
                  }
                  secondary={
                    <Stack direction="row" spacing={2} sx={{ mt: 0.5 }}>
                      <Typography variant="body2">DPI: {c.dpi || '—'}</Typography>
                      <Typography variant="body2">Tel: {c.telefono || '—'}</Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 'bold', color: deuda > 0 ? 'error.main' : 'success.main' }}
                      >
                        Deuda: Q {deuda.toFixed(2)}
                      </Typography>
                    </Stack>
                  }
                />
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          );
        })}
      </List>
    </Box>
  );
};

export default ListaClientes;
